<template>
  <v-app>
    <v-app-bar app color="primary" dark>
      <div class="d-flex align-center">
        <v-img
          alt="Neumaticos las Delicias Logo"
          class="shrink mr-2"
          contain
          src="img/logo neumaticos.jpg"
          transition="scale-transition"
          width="60"
        />
      </div>
      <v-spacer />

      <v-spacer></v-spacer>
      <a
        class="font-weight-light headline nolink mr-4"
        href="https://wa.me/+34952320023?text=Buenas, quería un presupuesto."
        target="_blank"
      >
        <v-icon
          color="green darken-2"
          class="mx-4"
          :size="$vuetify.breakpoint.smAndDown ? '30' : '50'"
          dark
          >mdi-whatsapp</v-icon
        >
      </a>
      <a class="font-weight-light headline nolink mr-4" href="tel://952320023">
        <v-row align="center">
          <v-icon
            color="secondary darken-2"
            class="mr-2"
            :size="$vuetify.breakpoint.smAndDown ? '30' : '50'"
            dark
            >mdi-phone-in-talk</v-icon
          >
          <div class="title text-right d-none d-sm-none d-md-flex black--text">
            952 320 023 |
          </div>
        </v-row>
      </a>
      <v-btn color="black" text @click="$vuetify.goTo('#donde')">
        <span class="mr-2">Donde estamos</span>
      </v-btn>
      <!--<v-btn color="black" text>
        <span class="mr-2">Contacto</span>
      </v-btn>-->
      <!--
      <v-btn
        class="black d-none d-sm-flex"
        href="https://www.google.com/search?q=neumaticos+las+delicias&rlz=1C5CHFA_enES894ES894&oq=neu&aqs=chrome.0.69i59j69i57j35i39j0l3j69i61l2.955j0j7&sourceid=chrome&ie=UTF-8#lrd=0xd72f9d5b3a9d7f3:0xf365200f6249556e,1,,,"
        target="_blank"
        text
      >
        <span class="mr-2">Opiniones</span>
        <v-icon>mdi-open-in-new</v-icon>
      </v-btn>-->
    </v-app-bar>

    <v-content>
      <router-view />
    </v-content>
    <v-footer class="justify-center" color="primary">
      <v-row>
        <v-col cols="12" md="4">
          <v-row justify="center" justify-md="start">
            <div class="subtitle-1 font-weight-light black--text ml-2">
              &copy; {{ new Date().getFullYear() }} — Neumáticos Las Delicias
            </div>
          </v-row>
        </v-col>
        <v-col cols="12" md="4">
          <!--<v-row justify="center" justify-md="center">
            <a href="https://www.facebook.com/MilanoIngenieria/" target="_blank">
              <v-icon large color="white darken-2">mdi-facebook</v-icon>
            </a>
            <a href="https://twitter.com/milanoingenieri" target="_blank">
              <v-icon large color="white darken-2" class="mx-4">mdi-twitter</v-icon>
            </a>
            <a href="https://www.linkedin.com/company/milano-ingenier%C3%ADa/" target="_blank">
              <v-icon large color="white darken-2">mdi-linkedin</v-icon>
            </a>
          </v-row>-->
        </v-col>
        <v-col cols="12" md="4">
          <v-row justify="center" justify-md="end" class="pb-2 mr-2">
            <div
              class="subtitle-1 font-weight-light black--text text-right mr-4"
            >
              &copy;
              <a
                class="nolink black--text"
                @click="$router.push('/terminos-condiciones')"
              >
                <span class="text-no-wrap">Términos y condiciones</span>
              </a>
            </div>
          </v-row>
        </v-col>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  name: "App",

  data: () => ({
    //
  }),
};
</script>
